// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ShopAnalyzer.css */

.main-title-container {
  position: relative;
  padding: 20px 20px 20px 80px; /* Extra padding-left for logo space */
  border: 2px solid #555;
  border-radius: 10px;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #1a1a20 0%, #2a2a35 100%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.logo-image {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  height: 60px; /* Adjust size as needed */
  width: auto;
}

.title-text h1 {
  margin: 0;
  padding: 0;
  font-size: 2.2rem;
  font-weight: 700;
  background: linear-gradient(45deg, #4facfe, #00f2fe);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-text p {
  margin-top: 8px;
  color: #bbb;
  font-size: 1.05rem;
}



.shop-analyzer-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #1a1a20 0%, #262630 100%);
    color: #f0f0f0;
    padding: 10px 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  
  .main-title-container {
    border: 2px solid #555;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 30px;
    text-align: center;
    background: linear-gradient(135deg, #1a1a20 0%, #2a2a35 100%);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  }
  
  .main-title-container h1 {
    margin: 0;
    padding: 0;
    color: #f0f0f0;
    font-size: 2.5rem;
    font-weight: 700;
    background: linear-gradient(45deg, #4facfe, #00f2fe);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .main-title-container p {
    margin-top: 10px;
    color: #bbb;
    font-size: 1.1rem;
  }
  
  .analyzer-layout {
    display: grid;
    grid-template-columns: 1.5fr 2fr 1fr;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  @media (max-width: 1200px) {
    .analyzer-layout {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }
  
  .column-container {
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    border: 1px solid #444;
    display: flex;
    flex-direction: column;
    min-height: 500px;
  }
  
  .column-bg-1 {
    background: linear-gradient(135deg, #262730 0%, #2a2a35 100%);
  }
  
  .column-bg-2 {
    background: linear-gradient(135deg, #1a1a20 0%, #1e1e28 100%);
  }
  
  .column-bg-3 {
    background: linear-gradient(135deg, #262730 0%, #2a2a35 100%);
  }
  
  .column-container h2 {
    margin-top: 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #555;
    margin-bottom: 20px;
    color: #f0f0f0;
    font-size: 1.5rem;
  }
  
  /* Input Method Selector */
  .input-method-selector {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }
  
  .radio-option {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 1.1rem;
    color: #ddd;
    transition: color 0.2s;
  }
  
  .radio-option:hover {
    color: #4facfe;
  }
  
  .radio-option input[type="radio"] {
    margin: 0;
    transform: scale(1.2);
  }
  
  /* Upload Section */
  .upload-section {
    flex: 1 1;
  }
  
  .drag-drop-area {
    border: 2px dashed #555;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.02);
  }
  
  .drag-drop-area:hover {
    border-color: #4facfe;
    background: rgba(79, 172, 254, 0.1);
    transform: translateY(-2px);
  }
  
  .drag-drop-area svg {
    color: #888;
    margin-bottom: 15px;
    transition: color 0.3s;
  }
  
  .drag-drop-area:hover svg {
    color: #4facfe;
  }
  
  .drag-drop-area p {
    margin: 10px 0 5px 0;
    font-size: 1.1rem;
    color: #ddd;
  }
  
  .drag-drop-area small {
    color: #999;
  }
  
  /* Camera Section */
  .camera-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .camera-button, .capture-button, .stop-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .camera-button {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: white;
  }
  
  .camera-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
  }
  
  .capture-button {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
    color: white;
  }
  
  .capture-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(67, 233, 123, 0.4);
  }
  
  .stop-button {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
    color: white;
  }
  
  .stop-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(250, 112, 154, 0.4);
  }
  
  .camera-controls {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  /* Action Buttons */
  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }
  
  .analyze-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .analyze-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
  
  .analyze-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
  
  .reset-button {
    padding: 12px;
    background: transparent;
    color: #ddd;
    border: 1px solid #555;
    border-radius: 8px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .reset-button:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: #777;
  }
  
  /* Spinner Animation */
  .spinner {
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  /* Error Message */
  .error-message {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px;
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.3);
    border-radius: 8px;
    color: #fca5a5;
    margin-top: 15px;
    font-size: 0.9rem;
  }
  
  /* Image Preview */
  .image-preview-container {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.02);
  }
  
  .image-preview, .camera-video {
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  }
  
  .camera-video {
    width: 100%;
    height: auto;
  }
  
  .image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #888;
    text-align: center;
    padding: 40px;
  }
  
  .image-placeholder svg {
    margin-bottom: 15px;
  }
  
  .image-placeholder p {
    margin: 0;
    font-size: 1.1rem;
  }
  
  /* Results Container */
  .results-container {
    flex: 1 1;
    display: flex;
    flex-direction: column;
  }
  
  .analyzing-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex: 1 1;
    gap: 15px;
  }
  
  .analyzing-state .spinner {
    color: #4facfe;
  }
  
  .analyzing-state p {
    margin: 0;
    font-size: 1.1rem;
    color: #ddd;
  }
  
  .analyzing-state small {
    color: #999;
  }
  
  .no-results {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1;
    text-align: center;
    color: #888;
  }
  
  .results-content {
    flex: 1 1;
  }
  
  .shop-detection-status {
    margin-bottom: 20px;
  }
  
  .detection-positive, .detection-negative {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.1rem;
    font-weight: 600;
  }
  
  .detection-positive {
    color: #10b981;
  }
  
  .detection-negative {
    color: #ef4444;
  }
  
  .shops-details {
    margin-top: 20px;
  }
  
  .shop-detail {
    margin: 15px 0;
  }
  
  .shop-detail h4 {
    margin: 0 0 10px 0;
    color: #4facfe;
    font-size: 1.1rem;
  }
  
  .shop-info {
    margin-left: 10px;
  }
  
  .shop-info p {
    margin: 5px 0;
    color: #ddd;
  }
  
  .shop-info strong {
    color: #f0f0f0;
  }
  
  .shops-details hr {
    border: none;
    height: 1px;
    background: #555;
    margin: 15px 0;
  }
  
  .warning-message {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 15px;
    background: rgba(245, 158, 11, 0.1);
    border: 1px solid rgba(245, 158, 11, 0.3);
    border-radius: 8px;
    color: #fbbf24;
    margin-top: 15px;
  }
  
  .warning-message p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  /* Footer */
  .app-footer {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
  }
  
  .app-footer hr {
    border: none;
    height: 1px;
    background: #555;
    margin-bottom: 15px;
  }
  
  .app-footer p {
    margin: 0;
    color: #888;
    font-size: 0.9rem;
  }`, "",{"version":3,"sources":["webpack://./src/components/ShopAnalyzer.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,4BAA4B,EAAE,sCAAsC;EACpE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,6DAA6D;EAC7D,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,YAAY,EAAE,0BAA0B;EACxC,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;;;AAIA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,cAAc;IACd,kBAAkB;IAClB,8EAA8E;EAChF;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,6DAA6D;IAC7D,yCAAyC;EAC3C;;EAEA;IACE,SAAS;IACT,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,oDAAoD;IACpD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE;MACE,0BAA0B;MAC1B,SAAS;IACX;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;EACnB;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA,mBAAmB;EACnB;IACE,SAAO;EACT;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,qCAAqC;EACvC;;EAEA;IACE,qBAAqB;IACrB,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,mBAAmB;EACnB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,6DAA6D;IAC7D,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,6DAA6D;IAC7D,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,6DAA6D;IAC7D,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,kCAAkC;EACpC;;EAEA;IACE,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;EAClC;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,kBAAkB;EAClB;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAO;IACP,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAO;IACP,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,aAAa;IACb,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB","sourcesContent":["/* ShopAnalyzer.css */\n\n.main-title-container {\n  position: relative;\n  padding: 20px 20px 20px 80px; /* Extra padding-left for logo space */\n  border: 2px solid #555;\n  border-radius: 10px;\n  margin-bottom: 30px;\n  background: linear-gradient(135deg, #1a1a20 0%, #2a2a35 100%);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n  text-align: center;\n}\n\n.logo-image {\n  position: absolute;\n  top: 50%;\n  left: 20px;\n  transform: translateY(-50%);\n  height: 60px; /* Adjust size as needed */\n  width: auto;\n}\n\n.title-text h1 {\n  margin: 0;\n  padding: 0;\n  font-size: 2.2rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #4facfe, #00f2fe);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.title-text p {\n  margin-top: 8px;\n  color: #bbb;\n  font-size: 1.05rem;\n}\n\n\n\n.shop-analyzer-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #1a1a20 0%, #262630 100%);\n    color: #f0f0f0;\n    padding: 10px 20px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  }\n  \n  .main-title-container {\n    border: 2px solid #555;\n    padding: 20px;\n    border-radius: 10px;\n    margin-bottom: 30px;\n    text-align: center;\n    background: linear-gradient(135deg, #1a1a20 0%, #2a2a35 100%);\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n  }\n  \n  .main-title-container h1 {\n    margin: 0;\n    padding: 0;\n    color: #f0f0f0;\n    font-size: 2.5rem;\n    font-weight: 700;\n    background: linear-gradient(45deg, #4facfe, #00f2fe);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n  }\n  \n  .main-title-container p {\n    margin-top: 10px;\n    color: #bbb;\n    font-size: 1.1rem;\n  }\n  \n  .analyzer-layout {\n    display: grid;\n    grid-template-columns: 1.5fr 2fr 1fr;\n    gap: 20px;\n    margin-bottom: 30px;\n  }\n  \n  @media (max-width: 1200px) {\n    .analyzer-layout {\n      grid-template-columns: 1fr;\n      gap: 15px;\n    }\n  }\n  \n  .column-container {\n    padding: 20px;\n    border-radius: 12px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n    border: 1px solid #444;\n    display: flex;\n    flex-direction: column;\n    min-height: 500px;\n  }\n  \n  .column-bg-1 {\n    background: linear-gradient(135deg, #262730 0%, #2a2a35 100%);\n  }\n  \n  .column-bg-2 {\n    background: linear-gradient(135deg, #1a1a20 0%, #1e1e28 100%);\n  }\n  \n  .column-bg-3 {\n    background: linear-gradient(135deg, #262730 0%, #2a2a35 100%);\n  }\n  \n  .column-container h2 {\n    margin-top: 0;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #555;\n    margin-bottom: 20px;\n    color: #f0f0f0;\n    font-size: 1.5rem;\n  }\n  \n  /* Input Method Selector */\n  .input-method-selector {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 20px;\n  }\n  \n  .radio-option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 1.1rem;\n    color: #ddd;\n    transition: color 0.2s;\n  }\n  \n  .radio-option:hover {\n    color: #4facfe;\n  }\n  \n  .radio-option input[type=\"radio\"] {\n    margin: 0;\n    transform: scale(1.2);\n  }\n  \n  /* Upload Section */\n  .upload-section {\n    flex: 1;\n  }\n  \n  .drag-drop-area {\n    border: 2px dashed #555;\n    border-radius: 8px;\n    padding: 40px 20px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background: rgba(255, 255, 255, 0.02);\n  }\n  \n  .drag-drop-area:hover {\n    border-color: #4facfe;\n    background: rgba(79, 172, 254, 0.1);\n    transform: translateY(-2px);\n  }\n  \n  .drag-drop-area svg {\n    color: #888;\n    margin-bottom: 15px;\n    transition: color 0.3s;\n  }\n  \n  .drag-drop-area:hover svg {\n    color: #4facfe;\n  }\n  \n  .drag-drop-area p {\n    margin: 10px 0 5px 0;\n    font-size: 1.1rem;\n    color: #ddd;\n  }\n  \n  .drag-drop-area small {\n    color: #999;\n  }\n  \n  /* Camera Section */\n  .camera-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .camera-button, .capture-button, .stop-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 20px;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .camera-button {\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n    color: white;\n  }\n  \n  .camera-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);\n  }\n  \n  .capture-button {\n    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n    color: white;\n  }\n  \n  .capture-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(67, 233, 123, 0.4);\n  }\n  \n  .stop-button {\n    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);\n    color: white;\n  }\n  \n  .stop-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 15px rgba(250, 112, 154, 0.4);\n  }\n  \n  .camera-controls {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  /* Action Buttons */\n  .action-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 20px;\n  }\n  \n  .analyze-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 15px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .analyze-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n  }\n  \n  .analyze-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n  }\n  \n  .reset-button {\n    padding: 12px;\n    background: transparent;\n    color: #ddd;\n    border: 1px solid #555;\n    border-radius: 8px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .reset-button:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: #777;\n  }\n  \n  /* Spinner Animation */\n  .spinner {\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n  \n  /* Error Message */\n  .error-message {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px;\n    background: rgba(239, 68, 68, 0.1);\n    border: 1px solid rgba(239, 68, 68, 0.3);\n    border-radius: 8px;\n    color: #fca5a5;\n    margin-top: 15px;\n    font-size: 0.9rem;\n  }\n  \n  /* Image Preview */\n  .image-preview-container {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 300px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.02);\n  }\n  \n  .image-preview, .camera-video {\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n  }\n  \n  .camera-video {\n    width: 100%;\n    height: auto;\n  }\n  \n  .image-placeholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #888;\n    text-align: center;\n    padding: 40px;\n  }\n  \n  .image-placeholder svg {\n    margin-bottom: 15px;\n  }\n  \n  .image-placeholder p {\n    margin: 0;\n    font-size: 1.1rem;\n  }\n  \n  /* Results Container */\n  .results-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .analyzing-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    flex: 1;\n    gap: 15px;\n  }\n  \n  .analyzing-state .spinner {\n    color: #4facfe;\n  }\n  \n  .analyzing-state p {\n    margin: 0;\n    font-size: 1.1rem;\n    color: #ddd;\n  }\n  \n  .analyzing-state small {\n    color: #999;\n  }\n  \n  .no-results {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n    text-align: center;\n    color: #888;\n  }\n  \n  .results-content {\n    flex: 1;\n  }\n  \n  .shop-detection-status {\n    margin-bottom: 20px;\n  }\n  \n  .detection-positive, .detection-negative {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 1.1rem;\n    font-weight: 600;\n  }\n  \n  .detection-positive {\n    color: #10b981;\n  }\n  \n  .detection-negative {\n    color: #ef4444;\n  }\n  \n  .shops-details {\n    margin-top: 20px;\n  }\n  \n  .shop-detail {\n    margin: 15px 0;\n  }\n  \n  .shop-detail h4 {\n    margin: 0 0 10px 0;\n    color: #4facfe;\n    font-size: 1.1rem;\n  }\n  \n  .shop-info {\n    margin-left: 10px;\n  }\n  \n  .shop-info p {\n    margin: 5px 0;\n    color: #ddd;\n  }\n  \n  .shop-info strong {\n    color: #f0f0f0;\n  }\n  \n  .shops-details hr {\n    border: none;\n    height: 1px;\n    background: #555;\n    margin: 15px 0;\n  }\n  \n  .warning-message {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 15px;\n    background: rgba(245, 158, 11, 0.1);\n    border: 1px solid rgba(245, 158, 11, 0.3);\n    border-radius: 8px;\n    color: #fbbf24;\n    margin-top: 15px;\n  }\n  \n  .warning-message p {\n    margin: 0;\n    font-size: 0.9rem;\n    line-height: 1.4;\n  }\n  \n  /* Footer */\n  .app-footer {\n    text-align: center;\n    margin-top: 40px;\n    padding-top: 20px;\n  }\n  \n  .app-footer hr {\n    border: none;\n    height: 1px;\n    background: #555;\n    margin-bottom: 15px;\n  }\n  \n  .app-footer p {\n    margin: 0;\n    color: #888;\n    font-size: 0.9rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
